import { motion } from 'framer-motion';
import { META, PIECES, PRESS } from './data';

// HOME — printed catalogue cover. NOT a parallax fashion hero. Big serial numbers,
// a tipped-in single garment plate, table of contents.
export default function Home({ setPage }) {
  return (
    <div className="bg-[#F2E8D5] text-[#1F3A2E]">
      {/* CATALOGUE COVER — big serial-numbered plate with single tipped-in garment */}
      <section className="pt-32 pb-12 max-w-[1500px] mx-auto px-8 lg:px-14">
        <div className="grid lg:grid-cols-[1.4fr_1fr] gap-12 items-end">
          <div>
            <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#7B5527] mb-6">— Catalogue n° XLVII · Spring/Summer XXVI · Firenze —</p>
            <h1 className="font-serif text-[68px] sm:text-[110px] lg:text-[170px] leading-[0.86] tracking-[-0.02em] text-[#1F3A2E]">
              The<br /><span className="italic">whole</span><br />year, 8<br /><span className="italic">collections.</span>
            </h1>
            <p className="font-serif italic text-base lg:text-xl text-[#1F3A2E]/65 mt-6 max-w-md leading-[1.6]">A printed catalogue of forty-six pieces, no advertising, sent by post on the fourteenth of each month to fourteen hundred readers.</p>
          </div>
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="aspect-[3/4] overflow-hidden border-[6px] border-[#1F3A2E]/15 lg:translate-y-12 shadow-[0_8px_60px_rgba(31,58,46,0.15)]">
            <img src={PIECES[0].img} alt="" className="w-full h-full object-cover" />
          </motion.div>
        </div>
      </section>

      {/* TABLE OF CONTENTS — printed-style index */}
      <section className="bg-[#E5D9BC] border-y-[3px] border-[#1F3A2E] py-12">
        <div className="max-w-[1300px] mx-auto px-8 lg:px-14">
          <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#7B5527] mb-6 text-center">— Table of contents · Plates 1 — 46 —</p>
          <div className="grid md:grid-cols-2 gap-x-12 gap-y-3">
            {[
              { sec: 'I', t: 'Outerwear · 11 plates · pp. 4 — 27' },
              { sec: 'II', t: 'Knitwear · 14 plates · pp. 28 — 51' },
              { sec: 'III', t: 'Tailoring · 12 plates · pp. 52 — 81' },
              { sec: 'IV', t: 'Accessories · 9 plates · pp. 82 — 96' },
              { sec: 'V', t: 'Atelier essay · pp. 97 — 102' },
              { sec: 'VI', t: 'Index of cloths · pp. 103' },
            ].map(c => (
              <div key={c.sec} className="flex items-baseline gap-4 border-b border-dashed border-[#1F3A2E]/30 pb-2.5">
                <span className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#7B5527] shrink-0">§ {c.sec}</span>
                <span className="font-serif italic text-base text-[#1F3A2E]">{c.t}</span>
              </div>
            ))}
          </div>
          <button onClick={() => setPage('pieces')} data-testid="vm-home-cta" className="mt-9 mx-auto block bg-[#1F3A2E] text-[#F2E8D5] px-10 py-4 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-[#7B5527] transition-colors">Browse all 46 pieces →</button>
        </div>
      </section>

      {/* TIPPED-IN PLATES — 4 featured pieces as catalogue plates */}
      <section className="max-w-[1500px] mx-auto px-8 lg:px-14 py-14">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#7B5527] mb-6">— Four plates from the new issue —</p>
        <div className="grid md:grid-cols-4 gap-5">
          {PIECES.slice(0, 4).map((p, i) => (
            <motion.article key={p.code} initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }} className="group">
              <div className="aspect-[3/4] overflow-hidden border border-[#1F3A2E]/15 mb-3"><img src={p.img} alt="" className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-1000" loading="lazy" /></div>
              <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#7B5527]">Plate {String(i + 1).padStart(2, '0')} · {p.code}</p>
              <p className="font-serif italic text-lg leading-tight mt-1.5">{p.t}</p>
              <p className="font-serif text-base text-[#7B5527] mt-1">{p.price}</p>
            </motion.article>
          ))}
        </div>
      </section>

      {/* PRESS STRIP — typeset under hairline */}
      <section className="bg-[#1F3A2E] text-[#F2E8D5] py-8">
        <div className="max-w-[1500px] mx-auto px-8 lg:px-14 flex flex-wrap items-baseline gap-x-12 gap-y-3">
          <span className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#C2A36B] shrink-0">— Quoted in —</span>
          {PRESS.map(p => <span key={p} className="font-serif italic text-lg lg:text-xl text-[#F2E8D5]/85">{p}</span>)}
        </div>
      </section>
    </div>
  );
}
